import {
  groupCodesByName,
  type DatalensBulkPropertyGroup,
} from "./bulkPropertyGroups";

/**
 * 照合 API へ分割 POST するためのチャンク分割。
 * BE は同一リクエスト内の会社跨ぎ重複コードを1行にマージして companyName を
 * 「、」連結するため、コード単位（初出順）で分割して同一コードを必ず同じ
 * チャンクに入れる。これで分割してもマージ結果が分割なしと一致する
 */
export const chunkResolveGroups = (
  groups: DatalensBulkPropertyGroup[],
  chunkSize: number
): DatalensBulkPropertyGroup[][] => {
  const namesByCode = new Map<string, string[]>();
  for (const group of groups) {
    for (const code of group.codes) {
      const names = namesByCode.get(code) ?? [];
      if (!names.includes(group.name)) {
        names.push(group.name);
      }
      namesByCode.set(code, names);
    }
  }

  const toGroups = (
    codeEntries: Array<[string, string[]]>
  ): DatalensBulkPropertyGroup[] =>
    groupCodesByName(
      codeEntries.flatMap(([code, names]) =>
        names.map((name): [string, string] => [name, code])
      )
    );

  const entries = [...namesByCode];
  const chunks: DatalensBulkPropertyGroup[][] = [];
  for (let i = 0; i < entries.length; i += chunkSize) {
    chunks.push(toGroups(entries.slice(i, i + chunkSize)));
  }
  return chunks;
};

export const countUniqueCodes = (groups: DatalensBulkPropertyGroup[]): number =>
  new Set(groups.flatMap((group) => group.codes)).size;
